import {chart} from '@xh/hoist/cmp/chart';
import {creates, hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {AllocationWidgetModel} from './AllocationWidgetModel';

export const allocationWidget = hoistCmp.factory({
    model: creates(() => AllocationWidgetModel),
    render({model}) {
        return panel({
            item: chart()
        });
    }
});
